import React from 'react';
import cx from 'classnames';
import { makeStyles } from 'design-system/styles';

const NucleusLoadingSpinnerFullWrapper: React.FC<{
  position?: 'fixed' | 'absolute';
  opacity?: number;
  className?: string;
  children?: React.ReactNode;
}> = ({ children, position = 'fixed', opacity = 0.8, className }) => {
  const classes = useStyles();
  const rootClasses = cx({
    [classes.absolute]: position === 'absolute',
    [classes.fixed]: position === 'fixed',
  });
  return (
    <div
      style={{ background: `rgba(255, 255, 255, ${opacity})` }}
      className={cx(classes.wrapper, className, rootClasses)}
    >
      {children}
    </div>
  );
};

export default NucleusLoadingSpinnerFullWrapper;

const useStyles = makeStyles({
  wrapper: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  absolute: {
    position: 'absolute',
    zIndex: 99999,
  },
  fixed: {
    position: 'fixed',
    zIndex: 99999, // should be higer than anything in the page
  },
});
